import { RatingSentence } from '../types/rating-sentence';
import { Gender } from '../types/student';

export const getGenderedRatingText = (
  rating: RatingSentence,
  gender: Gender
): string =>
  gender === Gender.Male ? rating.text : rating.feminine ?? rating.text;
